import React from 'react';

interface TextWithBoldPrefixProps {
  text: string;
  boldPrefix?: boolean;
  className?: string;
}

const TextWithBoldPrefix = ({
  text,
  boldPrefix = true,
  className = '',
}: TextWithBoldPrefixProps) => {
  const match = text.match(/^\s*(.*?)\s*([:-])\s*(.*)$/);

  const prefix    = match ? match[1] : '';
  const delimiter = match ? match[2] : '';
  const rest      = match ? match[3] : text;

  const renderPrefix = boldPrefix ? (
    <strong>{prefix}</strong>
  ) : (
    <span>{prefix}</span>
  );

  const renderColon = boldPrefix ? (
    <strong>:</strong>
  ) : (
    <span>:</span>
  );

  return (
    <div className={`text-with-bold-prefix ${prefix.toLowerCase()} ${className}`}>
      {prefix && (
        <>
          {renderPrefix}

          {delimiter === ':' && renderColon}
          {delimiter === '-' && <span> - </span>}
        </>
      )}

      {rest && <span> {rest}</span>}
    </div>
  );
};

export default TextWithBoldPrefix;
